import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import Styles from './AccountItem.module.scss'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { Checkbox } from 'blaze-ui/Checkbox/Checkbox'
import { Pressable } from '@react-aria/interactions'
import cx from 'classnames'
import { Text } from 'blaze-ui/Text/Text'
import { channelTypeFromProvider } from 'components/ArticlePostPreview/ArticlePostPreviewContext'
import { useState } from 'react'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'

interface AccountItemProps {
  externalIntegration: ExternalIntegration
  isSelected: boolean
  onSelect: (integration: ExternalIntegration) => void
  isDisabled?: boolean
}

export const AccountItem = ({
  externalIntegration,
  isSelected,
  onSelect,

  isDisabled,
}: AccountItemProps) => {
  const [imageDidError, setImageDidError] = useState(false)
  const handleSelect = () => {
    onSelect(externalIntegration)
  }

  const imageSrc = imageDidError || !externalIntegration.picture ? Silhouette : externalIntegration.picture

  return (
    <div className={cx(Styles.container, { [Styles.disabled]: isDisabled })}>
      <Pressable onPress={handleSelect}>
        <div
          className={cx(Styles.root, { [Styles.selected]: isSelected })}
          aria-label={`Select account ${externalIntegration.name}`}
        >
          <div className={Styles.avatarContainer}>
            <div className={Styles.checkboxContainer}>
              <Checkbox
                isSelected={isSelected}
                onChange={handleSelect}
                color="var(--selected-fill)"
                aria-label="Select account"
              />
            </div>
            <img
              src={imageSrc}
              alt={externalIntegration.name}
              className={Styles.picture}
              onError={() => setImageDidError(true)}
            />
            <div className={Styles.channelIconContainer}>
              <ChannelIcon channel={channelTypeFromProvider[externalIntegration.provider]} size={20} />
            </div>
          </div>
          <div className={Styles.nameContainer}>
            <Text variant="metadata" lineClamp={1}>
              {externalIntegration.name}
            </Text>
          </div>
        </div>
      </Pressable>
    </div>
  )
}
